import { gql } from '@apollo/client'
import React from 'react'

import { qrcodesClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useBucketState = () => React.useContext(Context) || {}
export const useBucket = () => useBucketState()?.bucket || {}

const QUERY = gql`
  query Bucket($id: ID!, $filter: BucketFilter) {
    bucket(id: $id, filter: $filter) {
      id
      name
      qrcodesCount
      qrcodes {
        id
        activated
        bucketId
        data
        recordId
        type
        updatedAt
        insertedAt
      }
      insertedAt
      activated
    }
  }
`

const BucketLoader = ({ children, id }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: qrcodesClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default BucketLoader
